import { render, staticRenderFns } from "./Destination.vue?vue&type=template&id=3ba134a1&"
import script from "./Destination.vue?vue&type=script&lang=js&"
export * from "./Destination.vue?vue&type=script&lang=js&"
import style0 from "./Destination.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports